module.exports = __webpack_public_path__ + "img/Dafe-logo-01.2ccff2bc.png";